import { useState, useEffect } from 'react';
import { getApiOptions } from '../api/apiUtils';

/**
 * Custom hook to fetch and manage API options for any endpoint
 * @param {string} endpoint - API endpoint path (e.g., '/api/c/grades_add_api/')
 * @returns {object} - { apiOptions, loading, error, refetch }
 */
export const useApiOptions = (endpoint) => {
  const [apiOptions, setApiOptions] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchOptions = async () => {
    try {
      setLoading(true);
      setError(null);
      const options = await getApiOptions(endpoint);
      setApiOptions(options);
    } catch (err) {
      console.error(`Failed to fetch API options for ${endpoint}:`, err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (endpoint) {
      fetchOptions();
    }
  }, [endpoint]);

  return {
    apiOptions,
    loading,
    error,
    refetch: fetchOptions
  };
};

/**
 * Hook specifically for parts API options
 * @returns {object} - { apiOptions, loading, error, refetch }
 */
export const usePartsApiOptions = () => {
  return useApiOptions('/api/c/parts_add_api/');
};

